<template>
  <div class="bids-add-bulk-drop-loading">
    <div class="bids-add-bulk-drop-loading__progress">
      <HollowDotsSpinner
        :animation-duration="1000"
        :dot-size="12"
        :dots-num="3"
        :color="'#95a5a6'"
      />
    </div>
    <span class="bids-add-bulk-drop-loading__text">
      {{
        $t('ADVERTISEMENT.BULK_IMPORT.PROCESS_PROGRESS', {
          fileName,
        })
      }}
    </span>
  </div>
</template>

<script>
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';

export default {
  name: 'BidsAddBulkDropLoading',
  components: { HollowDotsSpinner },
  props: {
    fileName: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-drop-loading {
  width: rem-calc(400px);
  display: flex;
  flex-direction: column;

  &__progress {
    margin-bottom: $global-margin;
    display: flex;
    justify-content: center;
  }

  &__text {
    align-self: center;
    text-align: center;
  }
}
</style>
